import isUpgrade from './isUpgrade';
import isSas from './isSas';
import isUs from './isUs';

export default function isStatsigEnabled({ locale, pathname }) {
  switch (locale) {
    case 'en-US':
    case 'us':
      return isUs(pathname) && (isUpgrade(pathname) || isSas(pathname) || pathname?.includes('/stand-alone-supps/'));
    default:
      return false;
  }
}
